import { useFormContext } from 'react-hook-form';
import { createValidationRules } from '@alf/validators';
import {
  FORM_VALIDATION_TYPES,
  formBuilderValidationMap,
  InputField
} from '@namespace/forms';

const documentNumberValidator = {
  1: [
    {
      type: FORM_VALIDATION_TYPES.MAX_LENGTH_VALIDATOR,
      parameters: [15]
    },
    {
      type: FORM_VALIDATION_TYPES.REGEXP_VALIDATOR,
      parameters: [
        /^[A-Za-z0-9]{0,15}$/,
        'register.steps.personalInfo.documentNumberPattern'
      ]
    }
  ],
  3: [
    {
      type: FORM_VALIDATION_TYPES.MAX_LENGTH_VALIDATOR,
      parameters: [9]
    },
    {
      type: FORM_VALIDATION_TYPES.MIN_LENGTH_VALIDATOR,
      parameters: [5]
    },
    FORM_VALIDATION_TYPES.NUMBER_FORMAT_VALIDATOR
  ]
};

const DocumentNumberField = ({ name, rules = {}, ...props }) => {
  const { watch } = useFormContext();
  const documentType = watch('document');
  const formValidationMap = { ...formBuilderValidationMap };

  return (
    <InputField
      key={documentType}
      name={name}
      rules={{
        ...rules,
        ...createValidationRules(
          documentNumberValidator[documentType],
          formValidationMap
        )
      }}
      {...props}
    />
  );
};

export default DocumentNumberField;
